import { isDefined } from "@clipboard-health/util-ts";

import { CbhCustomChatMessage } from "./CbhCustomChatMessage";
import { type RenderCustomMessageProps } from "./type";
import { parseFacilityChatMessage } from "./utils";

export function ShiftTimeProposalResponseMessage(props: RenderCustomMessageProps) {
  const facilityMessage = parseFacilityChatMessage(props.message);
  return isDefined(facilityMessage) ? <CbhCustomChatMessage message={facilityMessage} /> : null;
}
